import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromPlaylist from './store/playlist.reducer';
import { PlaylistEffects } from './store/playlist.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromPlaylist.PLAYLIST_FEATURE_KEY, fromPlaylist.reducer),
    EffectsModule.forFeature([PlaylistEffects])
  ]
})
export class PlaylistDataAccessModule {}
